<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <AdminToolbar :class="b('toolbar')" />

    <AdminContent />
  </div>
</template>
